import { useEffect } from 'react';
import { connectRealtime } from '../services/realtime';

export default function useRealtimeSync({
  app,
  enabled = true,
  getToken,
  onInvalidate,
  onReconnect,
} = {}) {
  useEffect(() => {
    if (!enabled) return undefined;
    return connectRealtime({ app, getToken, onInvalidate, onReconnect });
  }, [app, enabled, getToken, onInvalidate, onReconnect]);
}
